import MentoringAllPrograms from './MentoringAllPrograms.vue';

export default MentoringAllPrograms;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/views/allprograms/index.ts